import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  pageTitleDefault,
  pageTitleAbout,
} from '../../constants';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prefer-stateless-function
class HelmetHeader extends Component {
  render() {
    let origin = '';

    if (typeof window !== 'undefined') {
      origin = window.location.origin || 'https://www.citizenmusic.com';
    }

    const { location } = this.props;
    const canonicalUrl = `${origin}${location.pathname}`;

    // todo: quick for now.
    const isAboutPage = location.pathname === '/about-us';
    const title = isAboutPage ? pageTitleAbout : pageTitleDefault;

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta property="og:title" content={title} />

        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:url" content={canonicalUrl} />

        <meta property="twitter:title" content={title} />
        <meta property="twitter:url" content={canonicalUrl} />
      </Helmet>
    );
  }
}

export default withRouter(HelmetHeader);



// WEBPACK FOOTER //
// ./src/components/HelmetHeader/index.js